import React from 'react'
import { Button } from '@ow/comps'

const DataInfo = function ({ checkedItems, users, wrongNum, onClickDelete }) {
  return (
    <div className="w-full h-10 flex flex-row items-center my-2 justify-between">
      <div>
        {checkedItems.length > 0 && (
          <Button type="error" onClick={onClickDelete}>
            移除
          </Button>
        )}
      </div>
      <p style={{ fontSize: '0.75rem' }}>
        <b>
          总计{users.length} 条用户信息，正确：
          <span className="text-info">{users.length - wrongNum}</span> 条 错误：
          <span className="text-error">{wrongNum}</span> 条
        </b>
      </p>
    </div>
  )
}
export default DataInfo
